"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PerformanceInterval = void 0;
// the values of this enum will be displayed on frontend
var PerformanceInterval;
(function (PerformanceInterval) {
    PerformanceInterval["_1Day"] = "1D";
    PerformanceInterval["_1Week"] = "1W";
    PerformanceInterval["_1Month"] = "1M";
    PerformanceInterval["Max"] = "Max";
})(PerformanceInterval = exports.PerformanceInterval || (exports.PerformanceInterval = {}));
